import Api from './api';
import axios from 'axios';

let source = null;
class GeoFeatureSearchApi {
  static getDocsByPoint = (projectSchema, pointX, pointY) => {
    const url = `v1/spatialsearch/${projectSchema}/docs/${pointX}/${pointY}`;

    if (source) source.cancel();
    source = axios.CancelToken.source();

    return Api.get(url, {
      cancelToken: source.token,
    })
      .then((response) => {
        return response.data;
      })
      .finally(() => {
        source = null;
      });
  };
}

export default GeoFeatureSearchApi;
